<template>
  <with-actions>
    <change-logs-filters v-model="filter"></change-logs-filters>
    <change-logs-list v-model="change_logs" :filter="query"></change-logs-list>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
export default {
  data: function () {
    return {
      change_logs: [],
      filter: {}
    };
  },
  methods: {},
  computed: {
    query() {
      let filter = this.filter;
      return _.omitBy(filter, (v) => {
        return _.isEmpty(v);
      });
    }
  },
  mounted() {
    this.$store.commit('setBreadcrumbs', [
      { to: { name: 'customers' }, text: 'Customers' },
      { to: { name: 'routes_change_logs' }, text: 'Change logs' }
    ]);
  }
};
</script>
